import { Button, Grid, Link, Typography, useTheme } from '@mui/material'
import { useRef } from 'react'
import { IoOpenOutline } from 'react-icons/io5'
import { hasKnownCvDates } from '../../utils/metropolitanCv'
import { FormType } from '../../utils/sharedTypes'
import MetropolitanCvNote from '../MetropolitanCvNote'

type CpfStatusPropsType = {
  form: FormType
  setForm: React.Dispatch<React.SetStateAction<FormType>>
}

const CpfStatusPreConfiguredRegistration = ({ form }: CpfStatusPropsType) => {
  const stepRef = useRef<HTMLDivElement>(null)
  const theme = useTheme()

  const cpf_action_string = form.data.product?.cpf_action_string || form.data.products[0]?.cpf_action_string
  const showMetropolitanCvNote = hasKnownCvDates({
    product: form.data.product,
    products: form.data.products,
    session: form.data.session,
    sessions: form.sessions,
  })

  return (
    <>
      <div ref={stepRef}>
        {/* Section d'accueil sympathique */}
        <Grid
          sx={{
            mt: 3,
            background: `linear-gradient(135deg, ${theme.palette.primary.light}15, ${theme.palette.secondary.light}15)`,
            borderRadius: 2,
          }}
        >
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <Typography variant="body1" color="text.secondary">
                Vous y êtes presque !
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body1" color="text.secondary">
                En cliquant sur le bouton ci-dessous, vous allez être redirigé vers votre espace Mon Compte Formation, à
                partir duquel vous pourrez finaliser votre demande d'inscription.
              </Typography>
            </Grid>
            {showMetropolitanCvNote && (
              <Grid item>
                <MetropolitanCvNote form={form} />
              </Grid>
            )}

            <Grid item sx={{ mt: 2, justifyContent: 'center', textAlign: 'center' }}>
              <Link
                href={`https://www.moncompteformation.gouv.fr/espace-prive/html/#/formation/recherche/${
                  cpf_action_string ?? ''
                }/${cpf_action_string ?? ''}`}
                sx={{
                  textDecoration: 'none',
                }}
              >
                <Button
                  variant="contained"
                  size="large"
                  endIcon={<IoOpenOutline size={20} />}
                  sx={{
                    py: 1.5,
                    px: 4,
                    borderRadius: 2,
                    textTransform: 'none',
                    fontSize: '1.1rem',
                    fontWeight: 600,
                    boxShadow: 2,
                    '&:hover': {
                      boxShadow: 4,
                      transform: 'translateY(-2px)',
                      transition: 'all 0.2s ease-in-out',
                    },
                  }}
                >
                  Finaliser mon inscription
                </Button>
              </Link>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  )
}

export default CpfStatusPreConfiguredRegistration
